module.exports = __webpack_public_path__ + "img/loans.9fb10acc.svg";